module.exports = "<%=baseUrl%>/38861cba61c66739c1452c3a71e39852.ttf";